module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.lessons) ? _c('table', {
    staticClass: "table table-striped table-bordered"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.lessons), function(lesson) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.courseName(lesson.courseId)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(lesson.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(lesson.week))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'videoChapters',
          params: {
            courseId: lesson.courseId,
            instanceId: lesson.instanceId,
            videoId: lesson.id
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-sm btn-success"
    }, [_vm._v("Open")])])], 1)])
  }))]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Course")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Week")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c53ad5b8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/my-lessons/MyLessons.vue
// module id = 2126
// module chunks = 2